import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, Subscription } from "rxjs";
import { CommonService } from "src/app/core/services/common.service";
import { PermissionService } from "src/app/core/services/permisson.service";
import { UserService } from "src/app/core/services/user.service";
import { PLReportService } from "src/app/core/services/system.service";
import { TdspCommonService } from "src/app/core/services/tdsp/tdsp-common.service";
import {
  componentsSideMenuOptions,
  defaultRole,
  DefaultSideBar,
  landingPageUrl,
} from "src/app/models/sidenav";
import {
  adspPfmMenus,
  AGN_ADV_LVL_ROLES,
  AGN_LVL_ROLES,
  bdspPfmMenus,
  dspPriorityKeyMap,
  NON_API_ADV_ROLES,
  READ_ONLY_ROLES,
  SUB_PATH,
  tdspPfmMenus,
  vdspPfmMenus,
} from "src/app/models/common";
import {
  platFormLevelMenu,
  agencyLevelMenu,
  advertiserLevelMenu,
} from "src/app/models/sidebar";
import { SystemService } from "src/app/core/services/system.service";
import { AppConfig } from "src/app/configs/app.config";
import { MGN_SERVE_ROLES } from "src/app/models/common";
import { obfuscate } from "../../utils/arrayUtils";

@Component({
  selector: "dmp-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  subscription: Subscription;
  sideMenu: string = "main_menu";
  suboptionSelected: string;
  defaultRole = defaultRole;
  landingPageUrl = landingPageUrl;

  platFormLevelMenu = platFormLevelMenu;
  agencyLevelMenu = agencyLevelMenu;
  advertiserLevelMenu = advertiserLevelMenu;

  role: string;
  agency_id;
  agency_advertiser_id;
  advertiser_id;
  platformRole: boolean = false;
  isClientPoliticalBoolean: boolean;
  isPLReportUser: boolean = false;
  subMenuOptions = [];
  selectedTab: string;
  selectedOptionsGroup: string;
  selectedPlatformType: string;
  selectedEntityGroup: string;
  componentName: string;
  componentId: string;
  componentContent: any = null;
  accountStatementViewPermission;
  defaultSideBar: DefaultSideBar;

  apnx_enabled: boolean;
  adsp_enabled: boolean;
  bdsp_enabled: boolean;
  tdspEnabled: boolean;
  dcoEnabled: boolean;
  cdp_enabled: boolean = false;
  hyperlocalEnabled: boolean;
  user_cdp_enabled: boolean = false;
  agc_cdp_enabled: boolean = false;
  offline_attribution_enabled: boolean;
  adsp_regions: Array<any>;
  readOnlyRole = new Set<any>();
  priorityDsp: string | null = null;

  subPath = SUB_PATH;
  instance: string;
  routeParamsObj;
  tdspPricingModel: string = '';
  disableGlobalOldMenu = false;

  dspTypes = {};
  offlineAttributeItem: Set<String> = new Set(["coupon_code"]);
  plfLibrariesGrp: Set<String> = new Set([
    "libraries",
    "adsp_libraries_us",
    "adsp_libraries_eu",
    "bdsp_librares",
    "tdsp_libraries",
  ]);
  pLReportGrp: Set<String> = new Set([
    "vdsp_reports",
    "adsp_reports_us",
    "adsp_reports_eu",
    "bdsp_reports",
    "tdsp_reports",
  ]);
  agencyReportAnalyticsGrp: Set<String> = new Set([
    "reports",
    "adsp_reports",
    "analytics",
    "bdsp_reports",
    "tdsp_reports",
  ]);
  agencyReportsGrp: Set<String> = new Set([
    "reports",
    "adsp_reports",
    "bdsp_reports",
    "tdsp_reports",
  ]);
  campaignMenus: Set<String> = new Set([
    "Insertion Orders",
    "Line Items",
  ]);
  clientDealViewPrm = "deal_client_view";
  filterSubMenu: Array<any> = [];

  roleWithPfmMenuBackAllowed: Set<String> = new Set([
    "platform_superadmin",
    "platform_admin",
    "account_manager",
    "finance_user",
  ]);

  roleWithAdvMenuBackAllowed: Set<String> = new Set([
    "platform_superadmin",
    "platform_admin",
    "account_manager",
    "agency_primary_admin",
    "agency_admin",
    "agency_user",
    "agency_reporting_user",
    "managed_agency_user",
    "finance_user",
    "self_read_only_agc_user",
    "agency_account_manager",
  ]);
  readonly whiteLabelMode: boolean;
  readonly supportedDSPs: Set<string>;

  public readonly BASE_CDP_V2_URL: string = AppConfig.BASE_CDP_V2_URL;
  private routerSubscription: Subscription;
  currentUrl: string = '';
  cdpAllowed: boolean = AppConfig.IS_CDP_ALLOWED;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private commonService: CommonService,
    private permissionService: PermissionService,
    private userService: UserService,
    private pLReportService: PLReportService,
    private activatedRoute: ActivatedRoute,
    private systemService: SystemService,
    private changeDetector: ChangeDetectorRef,
    private tdspCommonService: TdspCommonService
  ) {
    this.defaultSideBar = new DefaultSideBar();
    commonService.changeViewFromComponent$.subscribe((item) => {
      commonService.changeReportStatus(true);
      this.changeToSecondarySubMenu(item);
    });

    this.subscription = commonService.getMenuFlag().subscribe((flag) => {
      // menu change main / platform / advertiser
      commonService.changeReportStatus(true);
      // console.log('menu flag >> ', flag)
      this.getSideBarContent(flag);
      // flag ? this.changeToSecondaryMenu() : this.changeToMainMenu();
    });

    commonService.changeContentFromComponent.subscribe((data) => {
      this.componentContent = data;
    });

    commonService.changeSecondarySubMenu.subscribe((data) => {
      data.sideBarStatus.forEach((value) => {
        this.subMenuOptions.forEach((option) => {
          if (value.id == option.id) {
            option.active = value.status;
          }
        });
      });
    });

    this.whiteLabelMode = AppConfig.WHITE_LABEL_MODE;
    this.supportedDSPs = AppConfig.SUPPORTED_DSPS;
  }

  ngOnInit(): void {
    this.role = localStorage.getItem("role");
    this.priorityDsp = this.commonService.getPriorityDsp();
    this.user_cdp_enabled = localStorage.getItem("user_cdp_enabled") == "true";
    if (localStorage.getItem("clientPermissions")) {
      this.accountStatementViewPermission =
        this.permissionService.getClientPermission("show_account_statement");
    } else this.accountStatementViewPermission = true;

    if (
      this.role == "platform_superadmin" ||
      this.role == "platform_admin" ||
      this.role == "account_manager"
    ) {
      this.platformRole = true;
    }
    if (this.role == "platform_superadmin" || this.role == "platform_admin" 
        || this.role == 'account_manager' || this.role == "finance_user") {
      this.checkPLReportPerm();
    }
    this.getSystemInfo();
    this.readOnlyRole = READ_ONLY_ROLES;
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.url;
      });
  }

  getSystemInfo() {
    this.systemService.getInstanceDetails().subscribe((res) => {
      this.instance = res.is_self_signup_supported ? "live" : "live-uk";
      if (!res.is_self_signup_supported || AppConfig.WHITE_LABEL_MODE) {
        let noVdsp = false, noAdsp = false, noBdsp = false, noTdsp = false;

        if (AppConfig.WHITE_LABEL_MODE) {
          this.filterSubMenu.length = 0;

          noVdsp = !this.supportedDSPs.has("vizibl_dsp");
          if (noVdsp) this.filterSubMenu.push(...vdspPfmMenus);

          noAdsp = !this.supportedDSPs.has("amazon_dsp");
          if (noAdsp) this.filterSubMenu.push(...adspPfmMenus);

          noBdsp = !this.supportedDSPs.has("beeswax_dsp");
          if (noBdsp) this.filterSubMenu.push(...bdspPfmMenus);

          noTdsp = !this.supportedDSPs.has("trade_desk_dsp");
          if (noTdsp) this.filterSubMenu.push(...tdspPfmMenus);
        }

        this.platFormLevelMenu.forEach((menu) => {
          if (menu.children) {
            for (let index = menu.children.length - 1; index >= 0; index--) {
              const subMenu = menu.children[index];
              if (this.filterSubMenu.includes(subMenu.group)) {
                menu.children.splice(index, 1);
              }
            }
          }
        });

        if (noVdsp && noAdsp && noBdsp && noTdsp) {
          this.platFormLevelMenu = this.platFormLevelMenu.filter(
            (menu) => menu.name !== "Platform Libraries" && menu.name !== "P&L Report"
          );
        }
      }
    });
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  isTdspFixedPricing(): boolean {
    return this.tdspPricingModel === 'fixed_cpm' || this.tdspPricingModel === 'fixed_cpc';
  }

  isDspDisabled(dspType: string): boolean {
    const dspKeyMap: Record<string, string> = {
      vdsp: "apnx_enabled",
      adsp_us: "adsp_us_region",
      adsp_eu: "adsp_uk_region",
      bdsp: "bdsp_enabled",
      tdsp: "tdsp_enabled",
      tdsp_hyperlocal: "tdsp_hyperlocal_enabled",
    };

    const key = dspKeyMap[dspType];
    return key ? localStorage.getItem(key) === "false" : false;
  }

  getToolTip(dspType: string) {
    if (dspType == "vdsp" && localStorage.getItem("apnx_enabled") == "false") {
      return "You do not have access to the Global section - Old of Campaign Management & Reporting. Please contact the Agency Primary Admin for assistance.";
    } else if (
      dspType == "tdsp" &&
      localStorage.getItem("tdsp_enabled") == "false"
    ) {
      return "You do not have access to the Global section of Campaign Management & Reporting. Please contact the Agency Primary Admin for assistance.";
    } else if (
      dspType == "adsp_us" &&
      localStorage.getItem("adsp_us_region") == "false"
    ) {
      return "You do not have access to the US Amazon section of Campaign Management & Reporting. Please contact the Agency Primary Admin for assistance.";
    } else if (
      dspType == "adsp_eu" &&
      localStorage.getItem("adsp_uk_region") == "false"
    ) {
      return "You do not have access to the EU Amazon section of Campaign Management & Reporting. Please contact the Agency Primary Admin for assistance.";
    } else if (
      dspType == "bdsp" &&
      localStorage.getItem("bdsp_enabled") == "false"
    ) {
      return "You do not have access to the Restricted Inventory section of Campaign Management & Reporting. Please contact the Agency Primary Admin for assistance.";
    } else if (
      dspType == "tdsp_hyperlocal" &&
      localStorage.getItem("tdsp_hyperlocal_enabled") == "false"
    ) {
      return "You do not have access to the Hyperlocal section of Campaign Management & Reporting. Please contact the Agency Primary Admin for assistance.";
    }
  }

  getSideBarContent(flag) {
    this.changeMenu(flag);
    this.getPoliticalDetails();
  }

  isClientPolitical() {
    return this.isClientPoliticalBoolean;
  }

  advertiserMenuBackAllowed() {
    return this.roleWithAdvMenuBackAllowed.has(this.role);
  }

  platformMenuBackAllowed() {
    return this.roleWithPfmMenuBackAllowed.has(this.role);
  }

  advertiserMenuBackAction() {
    if (this.getSavedAdvertiser()) {
      this.router.navigate([`/advertiser/`]);
      this.selectedOptionsGroup = "advertiser";
      // this.changeMenu('main_menu');
    }
    if (this.getSavedAgencyAdvertiser()) {
      let currentUrl = this.router.url;
      let dsp = this.router.url.split("?")[0].split("/")[1];
      let redirect = this.subPath.includes(dsp)
        ? dsp == "dco"
          ? this.router.url.includes('/tdsp-hyperlocal/') ? '/tdsp-hyperlocal/agency-advertiser' : `/tdsp/agency-advertiser/`
          : `/${dsp}/agency-advertiser/`
        : "/agency-advertiser/";
      this.router.navigate([redirect], {
        queryParams: {
          agency_id: localStorage.getItem("agency_id"),
          adsp_region:
            this.route.snapshot.queryParamMap.get("adsp_region") ?? null,
        },
      });
      this.selectedOptionsGroup == "agency_advertisers";
      // this.changeMenu('platform_menu');
    }
  }

  getparams() {
    let params = {};
    if (this.getSavedAdvertiser()) {
      params["advertiser_id"] = this.getSavedAdvertiser();
    }
    if (this.getSavedAgencyAdvertiser()) {
      params["agency_advertiser_id"] = this.getSavedAgencyAdvertiser();
    } else if (this.getSavedAgency()) {
      params["agency_id"] = this.getSavedAgency();
    }
    return params;
  }

  getViewReportId(dspKey: string, isPlReport: boolean): string | null {
    const keyPrefix = "latest_unsaved_";
    const keySuffix = isPlReport ? "_view_pl_report" : "_view_report";

    // VDSP does not use dspType in the key
    const storageKey =
      dspKey === "vdsp"
        ? `${keyPrefix}${keySuffix.slice(1)}`
        : `${keyPrefix}${dspKey}${keySuffix}`;
    return localStorage.getItem(storageKey);
  }

  routeToViewReport(dspType = "vdsp", isPlReport = false) {
    let report_id;
    let region = null;

    let dspKey = dspType === 'tdsp_hyperlocal' ? 'tdsp' : dspType;

    report_id = this.getViewReportId(dspKey, isPlReport);

    if (report_id) {
      if (dspKey == "adsp_us" || dspKey == "adsp_eu") {
        region = dspKey.split("_")[1].toUpperCase();
        dspKey = "adsp";
      }

      this.suboptionSelected =
        dspKey == "vdsp" ? "view_report" : `${dspKey}_view_report`;
      let path =
        dspKey != "vdsp"
          ? `/${dspKey}/report/${report_id}/view`
          : `/report/${report_id}/view/`;

      this.router.navigate([path], {
        queryParams: { ...this.getparams(), adsp_region: region },
      });
    }
  }

  accessViewReport(type, isPlReport = false) {
    return !this.getViewReportId(type, isPlReport);
  }

  routeURL(item, params = null) {
    let queryParams = this.getparams();
    if (params) {
      queryParams["adsp_region"] = params;
    }

    this.router.navigate([item.routes], {
      queryParams: queryParams,
      // state: { sideMenu: this.sideMenu }
    });
  }

  checkPLReportPerm() {
    this.pLReportService.checkUserPlReportAccess().subscribe(
      (res) => { },
      (err) => {
        this.isPLReportUser = false;
      },
      () => {
        this.isPLReportUser = true;
      }
    );
  }

  getListPermission(component) {
    if (this.clientDealViewPrm == component && MGN_SERVE_ROLES.has(this.role)) {
      return false; // If menu group is deal && role is managed serve users role hide it.
    }
    return this.permissionService.getListPermissions(component);
  }

  getViewPermission(component) {
    return this.permissionService.getViewPermissions(component);
  }

  checkPlfLibPms() {
    return this.role != "platform_account_user";
  }

  checkPLReportPms() {
    return this.isPLReportUser;
  }

  checkAgcReportsPms(item) {
    if (this.agencyReportsGrp.has(item.group)) {
      return (
        this.getListPermission(item.listPer) &&
        this.role != "platform_account_user"
      );
    } else {
      return (
        this.getViewPermission(item.viewPer) &&
        this.role != "platform_account_user" &&
        !this.platformRole
      );
    }
  }

  getAdvertiserGroupListPermission(menuOption) {
    if (menuOption.entity == "campaign") {
      return (
        this.getListPermission(menuOption.listPer) &&
        this.defaultSideBar[menuOption.entity].view
      );
    } else if (menuOption.entity == "reports") {
      return (
        this.getListPermission(menuOption.listPer) &&
        this.role != "platform_account_user"
      );
    } else if (menuOption.entity == "analytics") {
      return (
        this.role != "platform_account_user" &&
        !this.platformRole &&
        this.getViewPermission(menuOption.viewPer) &&
        !this.getSavedAgencyAdvertiser()
      );
    } else if (this.offlineAttributeItem.has(menuOption.entity)) {
      return (
        this.getListPermission(menuOption.listPer) &&
        this.offline_attribution_enabled &&
        !this.readOnlyRole.has(this.role)
      );
    } else {
      return this.getListPermission(menuOption.listPer);
    }
  }

  getNavLink(menuOption, entity) {
    if (entity == "inventory_list") {
      return this.defaultSideBar[entity].view
        ? menuOption.navLink
        : menuOption.navLinkTwo;
    } else {
      return menuOption.navLink;
    }
  }

  getAdvertiserListPermission(subMenu) {
    if (subMenu.isPlatformEntity) {
      if (
        subMenu.entity == "inventory_list" ||
        subMenu.entity == "custom_location"
      ) {
        return (
          (this.getSavedAdvertiser()
            ? this.getListPermission(subMenu.advLstPrm)
            : this.getListPermission(subMenu.agAdvLstPrm)) &&
          this.defaultSideBar[subMenu.entity].view
        );
      } else if (subMenu.entity == "deals") {
        return (
          !this.getSavedAgencyAdvertiser() &&
          !this.isTdspFixedPricing() &&
          this.getListPermission(subMenu.advLstPrm) &&
          this.getListPermission(subMenu.listPer)
        );
      } else {
        return this.getSavedAdvertiser()
          ? this.getListPermission(subMenu.advLstPrm)
          : this.getListPermission(subMenu.agAdvLstPrm);
      }
    } else if (subMenu.entity == "analytics") {
      return (
        this.role != "platform_account_user" &&
        !this.platformRole &&
        this.getViewPermission(subMenu.viewPer) &&
        !this.getSavedAgencyAdvertiser()
      );
    } else {
      return this.getListPermission(subMenu.listPer);
    }
  }

  isClientWithPerm(menu) {
    if (
      MGN_SERVE_ROLES.has(this.role) &&
      (menu.entity == "account_statement" || menu.entity == "users")
    ) {
      return false; // Disable My accounts and users for Managaged Users.
    }
    if (menu.entity == "account_statement") {
      return (
        this.getViewPermission(menu.viewPer) &&
        this.accountStatementViewPermission
      );
    } else {
      if (menu.name == "Campaign Management & Reporting") {
        return (
          this.getListPermission(menu.listPer) ||
          this.getListPermission("report")
        );
      }
      return this.getListPermission(menu.listPer);
    }
  }

  getVDSPLibraryLastMenu(menu, subMenu) {
    if (menu.dspType == "vdsp") {
      if (subMenu.entiy == "deals") {
        return this.defaultSideBar.custom_location.view;
      } else if (subMenu.entity == "custom_location") {
        return !this.defaultSideBar.custom_location.view;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  changeMenu(flag) {
    this.sideMenu = flag.menu;
    if (this.sideMenu == "main_menu") {
      localStorage.removeItem("agency_id");
    }
    if (this.sideMenu == "platform_menu") {
      localStorage.setItem("agency_id", this.getSavedAgency());
    }
    this.selectedOptionsGroup = flag.optionGroup;
    this.suboptionSelected = flag.optionSubGroup;
    this.selectedPlatformType = flag.platformType;
    this.selectedEntityGroup = flag.entityGroup;
  }

  changeToSecondarySubMenu(item) {
    this.changeMenu({ menu: "option_menu" });
    this.subMenuOptions = componentsSideMenuOptions[item.component];
    this.componentId = item.component;
    this.selectedTab = item.selectedTab;
    this.componentName = item.componentName;
    this.getPoliticalDetails();
  }

  checkEnabledDSP() {
    this.dspTypes = {
      vdsp: this.apnx_enabled && (!this.whiteLabelMode || this.supportedDSPs.has('vizibl_dsp')),
      adsp_us: this.adsp_enabled && this.adsp_regions.includes("US") && (!this.whiteLabelMode || this.supportedDSPs.has('amazon_dsp_us')),
      adsp_eu: this.adsp_enabled && this.adsp_regions.includes("EU") && (!this.whiteLabelMode || this.supportedDSPs.has('amazon_dsp_eu')),
      bdsp: this.bdsp_enabled && (!this.whiteLabelMode || this.supportedDSPs.has('beeswax_dsp')),
      tdsp: this.tdspEnabled && (!this.whiteLabelMode || this.supportedDSPs.has('trade_desk_dsp')),
      dco: this.dcoEnabled,
      tdsp_hyperlocal: this.hyperlocalEnabled && (!this.whiteLabelMode || this.supportedDSPs.has('trade_desk_hyperlocal')),
      nonDSP: true,
    };
  }

  removeGlobalOld(menuItems: any[]): any[] {
    return menuItems
      .filter(item => item.name !== 'Global - Old')
      .map(item => {
        if (item.children && item.children.length > 0) {
          return {
            ...item,
            children: this.removeGlobalOld(item.children)
          };
        }
        return item;
      });
  }

  getPoliticalDetails() {
    this.agency_id = this.route.snapshot.queryParamMap.get("agency_id");
    this.agency_advertiser_id = this.activatedRoute.snapshot.queryParamMap.get(
      "agency_advertiser_id"
    );
    this.advertiser_id = this.route.snapshot.queryParamMap.get("advertiser_id");
    if (this.agency_id || this.agency_advertiser_id || this.advertiser_id) {
      this.permissionService
        .getConfig(
          this.agency_id
            ? this.agency_id
            : this.agency_advertiser_id
              ? this.agency_advertiser_id
              : this.advertiser_id,
          this.agency_id
            ? "agency"
            : this.agency_advertiser_id
              ? "agency-advertiser"
              : "advertiser"
        )
        .subscribe(
          (res) => {
            this.isClientPoliticalBoolean =
              res.data.vertical == "political" ? true : false;
            this.apnx_enabled = res.data.apnx_enabled;
            this.adsp_enabled = res.data.adsp_enabled;
            this.bdsp_enabled = res.data.bdsp_enabled;
            this.tdspEnabled = res.data.tdsp_enabled;
            this.adsp_regions = res.data.adsp_regions;
            this.cdp_enabled = res.data.cdp_enabled;
            this.dcoEnabled = res.data.dco_enabled;
            this.offline_attribution_enabled =
              res.data.enable_offline_attribution;
            this.hyperlocalEnabled = res.data.tdsp_hyperlocal_enabled;
            this.agc_cdp_enabled = res.data.agc_cdp_enabled || false;
            this.tdspPricingModel = res.data[this.tdspCommonService.getPricingKey('tdsp_pricing_model')];

            if (!this.platformRole) {
              if (this.apnx_enabled && !this.adsp_enabled && !this.tdspEnabled && !this.bdsp_enabled) {
                this.agencyLevelMenu = this.agencyLevelMenu.filter((menu) => menu.name != 'Campaign Management & Reporting');
                this.advertiserLevelMenu = this.advertiserLevelMenu.filter((menu) => menu.name != 'Campaign Management & Reporting')
              } else {
                this.disableGlobalOldMenu = true;
                this.agencyLevelMenu = this.removeGlobalOld(this.agencyLevelMenu);
                this.advertiserLevelMenu = this.removeGlobalOld(this.advertiserLevelMenu);
              }

            }

          },
          (err) => { },
          () => {
            this.checkEnabledDSP();
          }
        );
    }
  }

  isHyperlocalMenuAllowed(menu): boolean {
    return ['platform_superadmin', 'platform_admin', 'account_manager'].includes(this.role);
  }

  checkCdpPer() {
    if (this.getSavedAdvertiser()) {
      return this.cdp_enabled && this.user_cdp_enabled && this.cdpAllowed;
    }
    if (this.getSavedAgencyAdvertiser()) {
      return (
        this.cdp_enabled &&
        this.user_cdp_enabled &&
        this.agc_cdp_enabled &&
        this.cdpAllowed
      );
    }
  }

  getSavedAdvertiser() {
    let advertiser_id = this.route.snapshot.queryParamMap.get("advertiser_id");
    if (advertiser_id) return advertiser_id;
    return localStorage.getItem("advertiser_id");
  }

  getSavedAgency() {
    let agency_id = this.route.snapshot.queryParamMap.get("agency_id");
    if (agency_id) return agency_id;
    return localStorage.getItem("agency_id");
  }

  getSavedAgencyAdvertiser() {
    let agency_advertiser_id = this.route.snapshot.queryParamMap.get(
      "agency_advertiser_id"
    );
    if (agency_advertiser_id) return agency_advertiser_id;
    return localStorage.getItem("agency_advertiser");
  }

  selectedTabFromSubMenu(item) {
    this.selectedTab = item.id;
    this.commonService.changeStepFromSideMenu(item.id);
    this.commonService.contentFromSideMenu(this.componentContent);
  }

  isAdspPath() {
    return this.router.url.split("?")[0].split("/")[1];
  }

  getMenuNavLink(menu) {
    let subPath = "";
    let hasPath = false;
    this.priorityDsp = this.commonService.getPriorityDsp();
    const getDspPath = (
      tdsp: string | boolean,
      apnx: string | boolean,
      adsp: string | boolean,
      bdsp: string | boolean,
      tdsp_hyperlocal: string | boolean

    ): string => {
      const isTrue = (v: string | boolean) => v === true || v === "true";
      const priorityDspPath: Record<string, string> = {
        trade_desk_dsp: "/tdsp",
        amazon_dsp: "/adsp",
        beeswax_dsp: "/bdsp",
      };
      const priorityDspEnabled: Record<string, string | boolean> = {
        trade_desk_dsp: tdsp,
        amazon_dsp: adsp,
        beeswax_dsp: bdsp,
      };
      if (this.priorityDsp && isTrue(priorityDspEnabled[this.priorityDsp])) {
        return priorityDspPath[this.priorityDsp];
      }
      if (isTrue(tdsp)) return "/tdsp";
      if (isTrue(apnx) && this.platFormLevelMenu && !this.disableGlobalOldMenu) {
        hasPath = true;
        return "";
      }
      if (isTrue(adsp)) return "/adsp";
      if (isTrue(bdsp)) return "/bdsp";
      if (isTrue(tdsp_hyperlocal)) return "/tdsp-hyperlocal";

      return "";
    };
    if (menu.entityGroup == "all") {
      if (this.role != "managed_agency_user") {
        subPath = getDspPath(
          this.tdspEnabled,
          this.apnx_enabled,
          this.adsp_enabled,
          this.bdsp_enabled,
          this.hyperlocalEnabled
        );
      } else {
        subPath = getDspPath(
          localStorage.getItem("tdsp_enabled"),
          localStorage.getItem("apnx_enabled"),
          localStorage.getItem("adsp_us_region") === "true" ||
          localStorage.getItem("adsp_uk_region") === "true",
          localStorage.getItem("bdsp_enabled"),
          localStorage.getItem("tdsp_hyperlocal_enabled")

        );
      }
    }

    return this.role.includes("report")
      ? subPath + menu.reportNavLink
      : this.defaultSideBar.insertion_order.view
        ? subPath + menu.navLink
        : subPath + menu.LiteNavLink;
  }

  getPlatFormType() {
    if (this.priorityDsp && dspPriorityKeyMap[this.priorityDsp]) {
      return dspPriorityKeyMap[this.priorityDsp];
    }
    return this.apnx_enabled && !this.disableGlobalOldMenu
      ? "vdsp"
      : this.adsp_enabled
        ? "adsp"
        : this.bdsp_enabled
          ? "bdsp"
          : this.tdspEnabled
            ? "tdsp"
            : this.hyperlocalEnabled
              ? "tdsp_hyperlocal"
              : "";
  }

  getSubMenuNavLink(subMenu, level: "agency" | "advertiser" = "advertiser"): string {
    if (this.role.includes("report")) {
      return subMenu.reportNavLink;
    }

    if (subMenu.dspType === "tdsp") {
      const hasReportPerm = this.getListPermission("report");
      if (level === "advertiser") {
        if (!hasReportPerm) {
          return this.defaultSideBar.insertion_order.view
            ? "/tdsp/insertion-order"
            : subMenu.liteNavLink || subMenu.LiteNavLink;
        }
        return this.defaultSideBar.insertion_order.view
          ? subMenu.navLink
          : subMenu.liteNavLink || subMenu.LiteNavLink;
      } else if (level === "agency") {
        if (!hasReportPerm) {
          return "/tdsp/agency-advertiser";
        }
        return subMenu.navLink;
      }
    }

    if (level === "agency") {
      return subMenu.navLink;
    }

    return this.defaultSideBar.insertion_order.view
      ? subMenu.navLink
      : subMenu.liteNavLink || subMenu.LiteNavLink;
  }

  isDashboardComingSoon(subMenu: any, subMenuChild: any): boolean {
    const isDashboard =
      subMenuChild?.name === "Dashboard" ||
      subMenuChild?.name === "Agency Dashboard";
    const isComingSoonDsp =
      subMenu?.dspType && subMenu.dspType !== "tdsp" && subMenu.dspType !== "vdsp";
    return Boolean(isDashboard && isComingSoonDsp);
  }

  getGroup(menu, level) {
    if (level === "agency") {
      if (menu.dspType === "tdsp" && this.getListPermission("report")) {
        return "dashboard";
      }
      return "agency_advertisers";
    }

    const dspTypeMap: Record<string, string> = {
      vdsp: "vdsp",
      tdsp: "tdsp",
      adsp_eu: "adsp",
      adsp_us: "adsp",
      bdsp: "bdsp",
      tdsp_hyperlocal: "tdsp_hyperlocal",

    };

    const base = dspTypeMap[menu.dspType];
    if (!base) return "political";

    if (this.role.includes("report")) {
      return base === "vdsp" ? "reports" : `${base}_reports`;
    }

    if (menu.dspType === "tdsp" && this.getListPermission("report")) {
      return "tdsp_dashboard";
    }

    return this.defaultSideBar.insertion_order.view
      ? base === "vdsp"
        ? "campaigns"
        : `${base}_campaigns`
      : "political";
  }

  getAdspRegion() {
    if (this.role != "managed_agency_user") {
      if (this.adsp_enabled) {
        return this.adsp_regions.includes("US") ? "US" : "EU";
      }
    } else {
      if (
        (localStorage.getItem("adsp_us_region") == "true" ||
          localStorage.getItem("adsp_uk_region") == "true")
      ) {
        return localStorage.getItem("adsp_us_region") == "true" ? "US" : "EU";
      }
    }
    return null;
  }

  selectCategoryOptions(
    item: string = null,
    route?,
    PlatformType?,
    navigate = true,
    adsp_params = null,
    entityGroup?,
    isThirdHierarchy = false,
    isCdp = false
  ) {
    if (item) {
      this.selectedOptionsGroup =
        this.selectedOptionsGroup == item ? null : item;
      if (!isThirdHierarchy) {
        this.selectedPlatformType =
          this.selectedPlatformType == PlatformType ? null : PlatformType;
      }
    }
    if (isCdp) {
      let token = localStorage.getItem("token");
      let refresh = localStorage.getItem("refresh");
      let url = `${this.BASE_CDP_V2_URL}handler?` +
        `pref=${encodeURIComponent(obfuscate(token))}` +
        `&sref=${encodeURIComponent(obfuscate(refresh))}` +
        `&role=${this.role}` +
        `&name=${localStorage.getItem("first_name")}`;
 
      if ([...AGN_LVL_ROLES].includes(this.role)) {
        url += `&agency_id=${this.agency_id}`;
      } else if ([...NON_API_ADV_ROLES].includes(this.role)) {
        url += `&advertiser_id=${this.advertiser_id}`;
      } else if ([...AGN_ADV_LVL_ROLES].includes(this.role)) {
        url += `&advertiser_id=${this.agency_advertiser_id}`;
      }
      url += `&instance=${this.instance}`;
      window.open(url, "_blank")?.focus();
      return;
    }
    if (route && navigate) {
      //if u r in difftab and close will redirect and open again
      this.routeURL({ routes: route }, adsp_params);
    }
    if (item && !PlatformType) {
      //to close other dropdown if other is opend
      this.selectedPlatformType = null;
    }
    if (item && !entityGroup) {
      this.selectedEntityGroup = null;
    }
    if (!PlatformType && !entityGroup) {
      this.selectedEntityGroup = "all";
    }
    if (!item) {
      this.selectedPlatformType =
        this.selectedPlatformType == PlatformType ? null : PlatformType;
      this.selectedEntityGroup =
        this.selectedEntityGroup == entityGroup ? null : entityGroup;
    }
  }

  getBackLink(componentId: string): string {
    const url = landingPageUrl[componentId];
    if (url && this.router.url.includes('/tdsp-hyperlocal/')) {
      return url.replace(/^\/?tdsp\//, '/tdsp-hyperlocal/');
    }
    return url;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
